import { Component, input, ViewEncapsulation } from "@angular/core";
import { CurrencyPipe, DatePipe } from "@angular/common";
import { Bind } from "primeng/bind";
import { Card } from "primeng/card";
import { ButtonDirective } from "primeng/button";
import { RouterLink } from "@angular/router";

import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-booking-detail",
    templateUrl: "./booking-detail.component.html",
    styleUrl: "./booking-detail.component.less",
    encapsulation: ViewEncapsulation.None,
    imports: [TPipe, Bind, Card, ButtonDirective, RouterLink, CurrencyPipe, DatePipe]
})
export class BookingDetailComponent {
  readonly booking = input<any>(undefined);
  readonly client = input<any>(undefined);
  readonly selectedWorks = input<any>(undefined);
  readonly works = input<any>(undefined);

  getWorksItem(works_id: string, id: string) {
    return this.works().find(item => item.id === works_id);
  }

}
